import React,{ Component } from 'react';
import { Button, Table,Card,Popconfirm, message } from 'antd';
import {addKey} from "../../utils/utils";
import { route } from '../../routes/routes';
import { getUserList, disableUser, exportUserList } from '../../model/user/requests';
import {dbFields} from '../../model/user/column';
import storage from '../../utils/storage';
import { configs } from '../../config/config';
import * as XLSX from "xlsx"

class User extends Component {
    constructor(props){
        super(props)
        this.state = {
            data:[],
            isLoaded:false,
        } ;
        this.columns = [
            {
                title: dbFields.id.title,
                dataIndex: dbFields.id.key,
                key: dbFields.id.key,
              },
            {
              title: dbFields.name.title,
              dataIndex: dbFields.name.key,
              key: dbFields.name.key,
            },
            {
                title: dbFields.email.title,
                dataIndex: dbFields.email.key,
                key: dbFields.email.key,
            },
            {
                title: dbFields.groupName.title,
                dataIndex: dbFields.groupName.key,
                key: dbFields.groupName.key,
            },
            {
                title: dbFields.desc.title,
                dataIndex: dbFields.desc.key,
                key: dbFields.desc.key,
            },
            {
                title: 'Action',
                dataIndex: '1',
                key: 'action',
                render:(text,record)=>
                {
                    return (<>
                         <Popconfirm title="Are you sure？" okText="Yes" cancelText="No"
                            onConfirm={()=>this.handlerConfirm(record)}
                        > 
                            <Button
                            style={{background: "#851dd6",color:"white" }}
                             type='warn' >Disable</Button> 
                         </Popconfirm> 
                         <Button  style={{background: "#851dd6",color:"white" }} type="primary" onClick={this.handlerClick.bind(this,record)}> BindGroup  </Button>
                    </> )       
                } 
            }
          ];

    };

    componentDidMount(){
        let userList = [];
        getUserList().then(res => {
            if(res.data.code == 200){
                userList = addKey(res.data.data)
                for(let i=0;i<userList.length;i++){
                    if(userList[i].group){
                        userList[i].group_name = userList[i].group.name
                    }
                }
                this.setState({
                    data:userList,
                    isLoaded:true,
                })
            }else{
                message.warn(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    };

    handlerConfirm=(record)=>{
        let id = record.id
       disableUser({id:id}).then(res=>{
            if(res.data.code == 200){
                    let dataSource = [...this.state.data]
                    this.setState({ data: dataSource.filter(item => item.key !== record.key) });
            }else{
                message.error(res.data.msg)
            }
       }).catch(err=>{
            message.error(err)
       })
    };


    handlerClick = (record) => {
        this.props.history.push(route.user.bind_group+record.id)
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    toChangePasswd =(record)=>{
        if(!storage.check(configs.cache.tokenKey)){
            message.error("Token  had expired")
            this.props.history.push("/")
            return false
        }
        let bearerToken = storage.get(configs.cache.tokenKey);
        let id = bearerToken.id

        this.props.history.push(route.user.edit+id)
    }

    handlerExport = () => {
        exportUserList().then(res=>{
            if(res.data.code == 200){
                const data = res.data.data;
                console.log(data) // 假设后端返回的数据是一个数组
                // 检查响应数据格式
                if (!Array.isArray(data)) {
                    throw new Error('数据格式不正确');
                }
      
                const customHeaders = [
                  { header: 'ID', key: 'id' },
                  { header: 'Name', key: 'name' },
                  { header: 'Email', key: 'email' },
                  { header: 'Desc', key: 'desc' },
                  { header: 'GroupName', key: 'group' },
      
              ];
      
      
                // 将数据转换为工作表
                const worksheet = XLSX.utils.json_to_sheet(data);
      
                 // 设置表头
                 const headerRow = customHeaders.map(header => header.header);
                 XLSX.utils.sheet_add_aoa(worksheet, [headerRow], { origin: 'A1' });
      
                 // 将数据填充到工作表中
                 const dataRow = data.map(item => ({
                     id: item.id,
                     name: item.name,
                     value: item.value
                 }));
                 XLSX.utils.sheet_add_json(worksheet, dataRow, { header: customHeaders.map(h => h.key), skipHeader: true, origin: 'A2' });
      
                 // 创建工作簿
                 const workbook = XLSX.utils.book_new();
                 XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      
      
                // 生成 Excel 文件
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      
                // 创建 Blob 对象
                const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'data.xlsx'); // 设置下载文件名
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }else{
                message.warn(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
        
    }
    render(){
        return(
            <>
                <Card>
                    <Button  style={{background: "#851dd6",color:"white" }} onClick={this.toChangePasswd}>change password</Button>
                    <Button  style={{background: "#851dd6",color:"white" }} onClick={this.handlerExport}>Export</Button>
                </Card>
                <Table 
                     dataSource={ this.state.isLoaded ? this.state.data : [] }
                     columns={this.columns} 
                 />
            </>
        )
    }

}
export default User;